// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DyCj","input":"styles_input__EM54F"};